var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "50.75px",
    height: "50.5px",
    viewBox: "0 0 50.75 50.5",
    enableBackground: "new 0 0 50.75 50.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Trash") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.795,14.626c-0.337,1.012-1.687,1.518-2.698,1.18c-1.181-0.506-1.687-1.854-1.181-2.867 c1.855-4.216,5.903-7.083,10.625-7.083c6.409,0,11.468,5.397,11.468,11.805c0,4.723-2.698,9.106-6.914,10.962 c-1.518,0.675-2.53,2.023-2.53,3.71v0.843c0,1.182-0.843,2.193-2.023,2.193s-2.192-1.012-2.192-2.193v-1.012 c0-3.203,1.854-6.239,5.059-7.588c2.698-1.181,4.384-3.879,4.384-6.915c0-4.048-3.203-7.42-7.251-7.42 C22.506,10.241,19.976,11.927,18.795,14.626z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.541,38.911c1.519,0,2.867,1.18,2.867,2.866c0,1.518-1.349,2.866-2.867,2.866c-1.686,0-2.866-1.349-2.866-2.866 C22.675,40.091,23.855,38.911,25.541,38.911z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.e5ea4dfc.svg";
export { ForwardRef as ReactComponent };